import { render, staticRenderFns } from "./SemiologiaNeumologica.vue?vue&type=template&id=be494eee"
import script from "./SemiologiaNeumologica.vue?vue&type=script&lang=js"
export * from "./SemiologiaNeumologica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports